<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M408.4 470.6C305.6 470.6 222 387 222 284.2c0-102.8 83.6-186.4 186.4-186.4 102.7 0 186.4 83.6 186.4 186.4 0 102.8-83.6 186.4-186.4 186.4zm0-289.9c-57.1 0-103.6 46.5-103.6 103.6s46.5 103.5 103.6 103.5S512 341.3 512 284.2s-46.5-103.5-103.6-103.5zm165.7 745.5H139.2c-22.9 0-41.4-18.6-41.4-41.4v-24.9c0-99.3 0-149.1 22.5-193.4 20.1-39.3 51.3-70.5 90.5-90.5 44.3-22.6 94.1-22.6 193.4-22.6H574c22.9 0 41.4 18.5 41.4 41.4s-18.6 41.4-41.4 41.4H404.3c-86 0-129.2 0-155.8 13.5-23.5 12-42.3 30.8-54.4 54.4-12.6 24.8-13.5 64.1-13.5 139.2h393.5c22.9 0 41.4 18.6 41.4 41.4.1 23-18.5 41.5-41.4 41.5z" />
        <path d="M760.5 905.6c-22.9 0-41.4-18.6-41.4-41.4v-82.8h-82.8c-22.9 0-41.4-18.6-41.4-41.4 0-22.9 18.6-41.4 41.4-41.4h82.8v-82.8c0-22.9 18.6-41.4 41.4-41.4 22.9 0 41.4 18.6 41.4 41.4v82.8h82.8c22.9 0 41.4 18.6 41.4 41.4 0 22.9-18.6 41.4-41.4 41.4h-82.8v82.8c0 22.8-18.5 41.4-41.4 41.4z" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
